import { Badge, Button, Stack } from '@mui/material';
import { FC, memo, useMemo } from 'react';
import { AppointmentsNotConfirmPopupInner } from './AppointmentsNotConfirmPopupInner';
import { AppointmentCompleteInterface } from 'packages/blu-booking/src/interfaces/AppointmentComplete';
import { AppointmentNotificationInterface } from 'packages/blu-booking/src/interfaces/AppointmentNotification';
import { RootState, AppDispatch } from 'packages/blu-booking/src/store';
import { useSelector, useDispatch } from 'react-redux';
import {
  setAppointmentNotConfirmPopupOpen,
  setAppointmentsSlotNotOkPopupOpen,
} from '../../store/Calendar';

interface AppointmentsNotConfirmPopupInterface {
  notifications: AppointmentNotificationInterface;
  handlePosition: (appointment: AppointmentCompleteInterface) => void;
}

export const AppointmentsNotConfirmPopup: FC<AppointmentsNotConfirmPopupInterface> =
  memo(({ notifications, handlePosition }) => {
    // const { data } = useAppointmentsNotification();
    const { appointmentNotConfirmPopupOpen } = useSelector(
      (state: RootState) => state.bluBookingCalendars
    );
    const dispatch = useDispatch<AppDispatch>();

    const GetPopup = useMemo(() => {
      if (!appointmentNotConfirmPopupOpen) return null;
      return (
        <AppointmentsNotConfirmPopupInner handlePosition={handlePosition} />
      );
    }, [appointmentNotConfirmPopupOpen, handlePosition]);

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (
      <>
        {GetPopup}

        <Button
          variant="outlined"
          onClick={() => dispatch(setAppointmentNotConfirmPopupOpen(true))}
          // disabled={(data?.notConfirmedCount ?? 0) < 1}
        >
          <Stack
            direction="row"
            gap={1}
            flex="1"
            alignItems="center"
            sx={{ pr: '8px' }}
          >
            <Stack flex="1" sx={{ textAlign: 'left' }}>
              Da confermare
            </Stack>
            <Badge
              badgeContent={notifications?.notConfirmedCount ?? 0}
              // color={'#E77D22'}
              sx={{
                '& .MuiBadge-badge': {
                  fontWeight: 'bold',
                  fontSize: '15px',
                  minWidth: '40px',
                  lineHeight: '14px',
                  boxShadow:
                    '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
                  backgroundColor: 'var(--accent-dark-color)',
                  color: 'white',
                },
              }}
            />
          </Stack>
        </Button>
      </>
    );
  });
